import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, Users, Sparkles, ArrowRight } from "lucide-react";
import api from "../../api/client";

export default function AdminDashboard() {
  const [counts, setCounts] = useState({ blog: 0, staff: 0, services: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/blog?limit=100").then((r) => r.data.length).catch(() => 0),
      api.get("/staff").then((r) => r.data.length).catch(() => 0),
      api.get("/services").then((r) => r.data.length).catch(() => 0),
    ]).then(([blog, staff, services]) => setCounts({ blog, staff, services }));
  }, []);

  const cards = [
    { to: "/admin/blog", label: "Articles du blog", count: counts.blog, icon: FileText, color: "from-blue-500 to-cyan-500" },
    { to: "/admin/staff", label: "Professionnels", count: counts.staff, icon: Users, color: "from-indigo-500 to-purple-500" },
    { to: "/admin/services", label: "Services", count: counts.services, icon: Sparkles, color: "from-emerald-500 to-teal-500" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-outfit text-3xl font-bold text-slate-900 mb-2">Tableau de bord</h1>
      <p className="text-slate-500 mb-8">Gérez le contenu du site Psymed.</p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
        {cards.map(({ to, label, count, icon: Icon, color }) => (
          <Link
            key={to}
            to={to}
            className="bg-white rounded-3xl border border-slate-100 p-6 hover:shadow-lg hover:-translate-y-1 transition-all group"
          >
            <div className={`w-12 h-12 bg-gradient-to-br ${color} rounded-2xl flex items-center justify-center mb-4`}>
              <Icon className="w-5 h-5 text-white" />
            </div>
            <p className="text-3xl font-outfit font-bold text-slate-900">{count}</p>
            <p className="text-slate-500 text-sm mt-1">{label}</p>
            <div className="mt-4 text-[#2E4DB5] text-sm font-semibold flex items-center gap-1 group-hover:gap-2 transition-all">
              Gérer <ArrowRight className="w-4 h-4" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
